import { useEffect } from "react";

import Visionaries from "../components/Visionaries";
import ScrollTop from "../features/ScrollTop";

function MainAboutUs() {
  useEffect(() => {
    document.title = "About Us | AttnQ";
  }, []);

  return (
    <main className="h-fit w-full mt-14 p-8 lg:px-16 lg:py-12 shadow">
      <ScrollTop />
      <div>
        <p className="text-lg text-center mb-14 italic">
          AttnQ is stylized, witty, and short for "Attain Queue". The name
          captures the startup's mission and process in a clean and modern way.
        </p>

        <div className="flex flex-col lg:flex-row justify-center gap-10 mt-20">
          <div className="lg:max-w-[38vw]">
            <h2 className="text-xl font-semibold">What We Do?</h2>
            <p className="pt-2 text-gray-700">
              AttnQ capture buyer needs, queue them by priority, and surface
              them to vetted agents who can deliver.
              <br />
              <br />
              The result? Fewer cold calls, faster deals, and happier clients on
              both sides.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold">Why AttnQ?</h2>
            <ul className="list-disc list-inside space-y-2 pt-2 text-gray-700">
              <li>Smart buyer–agent matchmaking</li>
              <li>Zero spam, 100 % relevance</li>
              <li>Simplified workflow for agents</li>
              <li>Transparent, data-driven platform</li>
            </ul>
          </div>
        </div>
      </div>

      <Visionaries />
    </main>
  );
}

export default MainAboutUs;
